<div class="row">
    <div class="twelve columns">
        <h2 class="fieldset-title" style="font-size: x-large;">Quotas submitted by Finance</h2>
    </div>
</div>
<div class="row">
    <div class="two columns">
        <button soho-button="secondary" icon="refresh" (click)="GetQuotasReadyForPlanCreation()">Refresh</button>
    </div>
    <div class="two columns">
        <button soho-button="primary" type="button" (click)="RejectQuotas()" icon="reject" soho-tooltip
            title="Move selected quotas back to Finance team for review."><span>Reject</span></button>
    </div>
    <div class="three columns">
        <button class="btn-primary hide-focus" type="button" (click)="CreatePlans()" soho-tooltip
            title="Create plans by approving the selected Quotas.">Create Plans</button>
    </div>
</div>
<div class="row top-padding" soho-busyindicator [blockUI]="true" [text]="Message">
    <div class="twelve columns demo" role="main">
        <div soho-toolbar [maxVisibleButtons]="4">
            <soho-toolbar-title></soho-toolbar-title>
              <soho-toolbar-button-set>
                <soho-toolbar-more-button>
                    <div class="popupmenu-wrapper">
                      <ul soho-popupmenu id="my-popupmenu-element" class="popupmenu">
                        <li soho-popupmenu-item>
                          <a soho-popupmenu-label href="#" data-option="personalize-columns">{{'PersonalizeColumns' | sohoTranslate}}</a>
                        </li>
                        <li soho-popupmenu-separator></li>
                        <li soho-popupmenu-item>
                            <a soho-popupmenu-label href="#" data-option="export-to-excel">{{'ExportToExcel' | sohoTranslate}}</a>
                        </li>
                      </ul>
                    </div>
                  </soho-toolbar-more-button>
    
              </soho-toolbar-button-set>
            </div>
        <div soho-datagrid id="QuotaApprovedatagrid" [columns]="grid_Columns" [data]="data" [selectable]="'multiple'"
            [paging]="true" [pagesize]="10" filterable="true" [clickToSelect]="false"  [toolbar]="{results: true}"  ></div>
    </div>
</div>
